/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthenticatedRouteImport } from './routes/_unauthenticated'
import { Route as PendingRouteImport } from './routes/_pending'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UnauthenticatedLoginRouteImport } from './routes/_unauthenticated/login'
import { Route as PendingWaitlistRouteImport } from './routes/_pending/waitlist'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedPlannedMealsRouteImport } from './routes/_authenticated/planned-meals'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'
import { Route as AuthenticatedRecipesIndexRouteImport } from './routes/_authenticated/recipes.index'
import { Route as AuthenticatedMealPlanningSessionsIndexRouteImport } from './routes/_authenticated/meal-planning-sessions.index'
import { Route as AuthenticatedGroupsIndexRouteImport } from './routes/_authenticated/groups/index'
import { Route as AuthenticatedCollectionsIndexRouteImport } from './routes/_authenticated/collections.index'
import { Route as AuthenticatedRecipesIdRouteImport } from './routes/_authenticated/recipes.$id'
import { Route as AuthenticatedMealPlanningSessionsIdRouteImport } from './routes/_authenticated/meal-planning-sessions.$id'
import { Route as AuthenticatedJoinTokenRouteImport } from './routes/_authenticated/join/$token'
import { Route as AuthenticatedGroupsIdRouteImport } from './routes/_authenticated/groups/$id'
import { Route as AuthenticatedPersonalRecipesIndexRouteImport } from './routes/_authenticated/personal/recipes/index'
import { Route as AuthenticatedPersonalProgramsIndexRouteImport } from './routes/_authenticated/personal/programs/index'
import { Route as AuthenticatedPersonalPlannedMealsIndexRouteImport } from './routes/_authenticated/personal/planned-meals/index'
import { Route as AuthenticatedPersonalMealPlansIndexRouteImport } from './routes/_authenticated/personal/meal-plans/index'
import { Route as AuthenticatedPersonalMealPlanningSessionsIndexRouteImport } from './routes/_authenticated/personal/meal-planning-sessions/index'
import { Route as AuthenticatedPersonalListsIndexRouteImport } from './routes/_authenticated/personal/lists/index'
import { Route as AuthenticatedPersonalFoodLogIndexRouteImport } from './routes/_authenticated/personal/food-log/index'
import { Route as AuthenticatedPersonalCollectionsIndexRouteImport } from './routes/_authenticated/personal/collections/index'
import { Route as AuthenticatedGroupsIdIndexRouteImport } from './routes/_authenticated/groups/$id.index'
import { Route as AdminAdminUsersIndexRouteImport } from './routes/_admin/admin/users/index'
import { Route as AdminAdminAiIssuesIndexRouteImport } from './routes/_admin/admin/ai-issues/index'
import { Route as AuthenticatedRecipesIdEditRouteImport } from './routes/_authenticated/recipes.$id.edit'
import { Route as AuthenticatedPersonalRecipesCreateRouteImport } from './routes/_authenticated/personal/recipes/create'
import { Route as AuthenticatedPersonalPlannedMealsDateRouteImport } from './routes/_authenticated/personal/planned-meals/$date'
import { Route as AuthenticatedPersonalMealPlansIdRouteImport } from './routes/_authenticated/personal/meal-plans/$id'
import { Route as AuthenticatedPersonalListsIdRouteImport } from './routes/_authenticated/personal/lists/$id'
import { Route as AuthenticatedPersonalFoodLogDateRouteImport } from './routes/_authenticated/personal/food-log/$date'
import { Route as AuthenticatedGroupsIdManageRouteImport } from './routes/_authenticated/groups/$id.manage'
import { Route as AuthenticatedCollectionsFoodIdRouteImport } from './routes/_authenticated/collections.food.$id'
import { Route as AdminAdminAiIssuesIdRouteImport } from './routes/_admin/admin/ai-issues/$id'
import { Route as AuthenticatedSpacesSpaceIdRecipesIndexRouteImport } from './routes/_authenticated/spaces/$spaceId/recipes/index'
import { Route as AuthenticatedSpacesSpaceIdPlannedMealsIndexRouteImport } from './routes/_authenticated/spaces/$spaceId/planned-meals/index'
import { Route as AuthenticatedSpacesSpaceIdMealPlanningSessionsIndexRouteImport } from './routes/_authenticated/spaces/$spaceId/meal-planning-sessions/index'
import { Route as AuthenticatedSpacesSpaceIdCollectionsIndexRouteImport } from './routes/_authenticated/spaces/$spaceId/collections/index'
import { Route as AuthenticatedSpacesSpaceIdRecipesCreateRouteImport } from './routes/_authenticated/spaces/$spaceId/recipes/create'
import { Route as AuthenticatedSpacesSpaceIdPlannedMealsDateRouteImport } from './routes/_authenticated/spaces/$spaceId/planned-meals/$date'
import { Route as AuthenticatedPersonalCollectionsListIdRouteImport } from './routes/_authenticated/personal/collections/list.$id'

const UnauthenticatedRoute = UnauthenticatedRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const PendingRoute = PendingRouteImport.update({
  id: '/_pending',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedLoginRoute = UnauthenticatedLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const PendingWaitlistRoute = PendingWaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => PendingRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPlannedMealsRoute =
  AuthenticatedPlannedMealsRouteImport.update({
    id: '/planned-meals',
    path: '/planned-meals',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRecipesIndexRoute =
  AuthenticatedRecipesIndexRouteImport.update({
    id: '/recipes/',
    path: '/recipes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMealPlanningSessionsIndexRoute =
  AuthenticatedMealPlanningSessionsIndexRouteImport.update({
    id: '/meal-planning-sessions/',
    path: '/meal-planning-sessions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGroupsIndexRoute =
  AuthenticatedGroupsIndexRouteImport.update({
    id: '/groups/',
    path: '/groups/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCollectionsIndexRoute =
  AuthenticatedCollectionsIndexRouteImport.update({
    id: '/collections/',
    path: '/collections/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRecipesIdRoute = AuthenticatedRecipesIdRouteImport.update({
  id: '/recipes/$id',
  path: '/recipes/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMealPlanningSessionsIdRoute =
  AuthenticatedMealPlanningSessionsIdRouteImport.update({
    id: '/meal-planning-sessions/$id',
    path: '/meal-planning-sessions/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJoinTokenRoute = AuthenticatedJoinTokenRouteImport.update({
  id: '/join/$token',
  path: '/join/$token',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGroupsIdRoute = AuthenticatedGroupsIdRouteImport.update({
  id: '/groups/$id',
  path: '/groups/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPersonalRecipesIndexRoute =
  AuthenticatedPersonalRecipesIndexRouteImport.update({
    id: '/personal/recipes/',
    path: '/personal/recipes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonalProgramsIndexRoute =
  AuthenticatedPersonalProgramsIndexRouteImport.update({
    id: '/personal/programs/',
    path: '/personal/programs/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonalPlannedMealsIndexRoute =
  AuthenticatedPersonalPlannedMealsIndexRouteImport.update({
    id: '/personal/planned-meals/',
    path: '/personal/planned-meals/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonalMealPlansIndexRoute =
  AuthenticatedPersonalMealPlansIndexRouteImport.update({
    id: '/personal/meal-plans/',
    path: '/personal/meal-plans/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonalMealPlanningSessionsIndexRoute =
  AuthenticatedPersonalMealPlanningSessionsIndexRouteImport.update({
    id: '/personal/meal-planning-sessions/',
    path: '/personal/meal-planning-sessions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonalListsIndexRoute =
  AuthenticatedPersonalListsIndexRouteImport.update({
    id: '/personal/lists/',
    path: '/personal/lists/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonalFoodLogIndexRoute =
  AuthenticatedPersonalFoodLogIndexRouteImport.update({
    id: '/personal/food-log/',
    path: '/personal/food-log/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonalCollectionsIndexRoute =
  AuthenticatedPersonalCollectionsIndexRouteImport.update({
    id: '/personal/collections/',
    path: '/personal/collections/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGroupsIdIndexRoute =
  AuthenticatedGroupsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedGroupsIdRoute,
  } as any)
const AdminAdminUsersIndexRoute = AdminAdminUsersIndexRouteImport.update({
  id: '/admin/users/',
  path: '/admin/users/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAdminAiIssuesIndexRoute = AdminAdminAiIssuesIndexRouteImport.update({
  id: '/admin/ai-issues/',
  path: '/admin/ai-issues/',
  getParentRoute: () => AdminRoute,
} as any)
const AuthenticatedRecipesIdEditRoute =
  AuthenticatedRecipesIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedRecipesIdRoute,
  } as any)
const AuthenticatedPersonalRecipesCreateRoute =
  AuthenticatedPersonalRecipesCreateRouteImport.update({
    id: '/personal/recipes/create',
    path: '/personal/recipes/create',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonalPlannedMealsDateRoute =
  AuthenticatedPersonalPlannedMealsDateRouteImport.update({
    id: '/personal/planned-meals/$date',
    path: '/personal/planned-meals/$date',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonalMealPlansIdRoute =
  AuthenticatedPersonalMealPlansIdRouteImport.update({
    id: '/personal/meal-plans/$id',
    path: '/personal/meal-plans/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonalListsIdRoute =
  AuthenticatedPersonalListsIdRouteImport.update({
    id: '/personal/lists/$id',
    path: '/personal/lists/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonalFoodLogDateRoute =
  AuthenticatedPersonalFoodLogDateRouteImport.update({
    id: '/personal/food-log/$date',
    path: '/personal/food-log/$date',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGroupsIdManageRoute =
  AuthenticatedGroupsIdManageRouteImport.update({
    id: '/manage',
    path: '/manage',
    getParentRoute: () => AuthenticatedGroupsIdRoute,
  } as any)
const AuthenticatedCollectionsFoodIdRoute =
  AuthenticatedCollectionsFoodIdRouteImport.update({
    id: '/collections/food/$id',
    path: '/collections/food/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AdminAdminAiIssuesIdRoute = AdminAdminAiIssuesIdRouteImport.update({
  id: '/admin/ai-issues/$id',
  path: '/admin/ai-issues/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AuthenticatedSpacesSpaceIdRecipesIndexRoute =
  AuthenticatedSpacesSpaceIdRecipesIndexRouteImport.update({
    id: '/spaces/$spaceId/recipes/',
    path: '/spaces/$spaceId/recipes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSpacesSpaceIdPlannedMealsIndexRoute =
  AuthenticatedSpacesSpaceIdPlannedMealsIndexRouteImport.update({
    id: '/spaces/$spaceId/planned-meals/',
    path: '/spaces/$spaceId/planned-meals/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSpacesSpaceIdMealPlanningSessionsIndexRoute =
  AuthenticatedSpacesSpaceIdMealPlanningSessionsIndexRouteImport.update({
    id: '/spaces/$spaceId/meal-planning-sessions/',
    path: '/spaces/$spaceId/meal-planning-sessions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSpacesSpaceIdCollectionsIndexRoute =
  AuthenticatedSpacesSpaceIdCollectionsIndexRouteImport.update({
    id: '/spaces/$spaceId/collections/',
    path: '/spaces/$spaceId/collections/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSpacesSpaceIdRecipesCreateRoute =
  AuthenticatedSpacesSpaceIdRecipesCreateRouteImport.update({
    id: '/spaces/$spaceId/recipes/create',
    path: '/spaces/$spaceId/recipes/create',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSpacesSpaceIdPlannedMealsDateRoute =
  AuthenticatedSpacesSpaceIdPlannedMealsDateRouteImport.update({
    id: '/spaces/$spaceId/planned-meals/$date',
    path: '/spaces/$spaceId/planned-meals/$date',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPersonalCollectionsListIdRoute =
  AuthenticatedPersonalCollectionsListIdRouteImport.update({
    id: '/personal/collections/list/$id',
    path: '/personal/collections/list/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/home': typeof AuthenticatedHomeRoute
  '/planned-meals': typeof AuthenticatedPlannedMealsRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/waitlist': typeof PendingWaitlistRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/groups/$id': typeof AuthenticatedGroupsIdRouteWithChildren
  '/join/$token': typeof AuthenticatedJoinTokenRoute
  '/meal-planning-sessions/$id': typeof AuthenticatedMealPlanningSessionsIdRoute
  '/recipes/$id': typeof AuthenticatedRecipesIdRouteWithChildren
  '/collections': typeof AuthenticatedCollectionsIndexRoute
  '/groups': typeof AuthenticatedGroupsIndexRoute
  '/meal-planning-sessions': typeof AuthenticatedMealPlanningSessionsIndexRoute
  '/recipes': typeof AuthenticatedRecipesIndexRoute
  '/admin/ai-issues/$id': typeof AdminAdminAiIssuesIdRoute
  '/collections/food/$id': typeof AuthenticatedCollectionsFoodIdRoute
  '/groups/$id/manage': typeof AuthenticatedGroupsIdManageRoute
  '/personal/food-log/$date': typeof AuthenticatedPersonalFoodLogDateRoute
  '/personal/lists/$id': typeof AuthenticatedPersonalListsIdRoute
  '/personal/meal-plans/$id': typeof AuthenticatedPersonalMealPlansIdRoute
  '/personal/planned-meals/$date': typeof AuthenticatedPersonalPlannedMealsDateRoute
  '/personal/recipes/create': typeof AuthenticatedPersonalRecipesCreateRoute
  '/recipes/$id/edit': typeof AuthenticatedRecipesIdEditRoute
  '/admin/ai-issues': typeof AdminAdminAiIssuesIndexRoute
  '/admin/users': typeof AdminAdminUsersIndexRoute
  '/groups/$id/': typeof AuthenticatedGroupsIdIndexRoute
  '/personal/collections': typeof AuthenticatedPersonalCollectionsIndexRoute
  '/personal/food-log': typeof AuthenticatedPersonalFoodLogIndexRoute
  '/personal/lists': typeof AuthenticatedPersonalListsIndexRoute
  '/personal/meal-planning-sessions': typeof AuthenticatedPersonalMealPlanningSessionsIndexRoute
  '/personal/meal-plans': typeof AuthenticatedPersonalMealPlansIndexRoute
  '/personal/planned-meals': typeof AuthenticatedPersonalPlannedMealsIndexRoute
  '/personal/programs': typeof AuthenticatedPersonalProgramsIndexRoute
  '/personal/recipes': typeof AuthenticatedPersonalRecipesIndexRoute
  '/personal/collections/list/$id': typeof AuthenticatedPersonalCollectionsListIdRoute
  '/spaces/$spaceId/planned-meals/$date': typeof AuthenticatedSpacesSpaceIdPlannedMealsDateRoute
  '/spaces/$spaceId/recipes/create': typeof AuthenticatedSpacesSpaceIdRecipesCreateRoute
  '/spaces/$spaceId/collections': typeof AuthenticatedSpacesSpaceIdCollectionsIndexRoute
  '/spaces/$spaceId/meal-planning-sessions': typeof AuthenticatedSpacesSpaceIdMealPlanningSessionsIndexRoute
  '/spaces/$spaceId/planned-meals': typeof AuthenticatedSpacesSpaceIdPlannedMealsIndexRoute
  '/spaces/$spaceId/recipes': typeof AuthenticatedSpacesSpaceIdRecipesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/home': typeof AuthenticatedHomeRoute
  '/planned-meals': typeof AuthenticatedPlannedMealsRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/waitlist': typeof PendingWaitlistRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/join/$token': typeof AuthenticatedJoinTokenRoute
  '/meal-planning-sessions/$id': typeof AuthenticatedMealPlanningSessionsIdRoute
  '/recipes/$id': typeof AuthenticatedRecipesIdRouteWithChildren
  '/collections': typeof AuthenticatedCollectionsIndexRoute
  '/groups': typeof AuthenticatedGroupsIndexRoute
  '/meal-planning-sessions': typeof AuthenticatedMealPlanningSessionsIndexRoute
  '/recipes': typeof AuthenticatedRecipesIndexRoute
  '/admin/ai-issues/$id': typeof AdminAdminAiIssuesIdRoute
  '/collections/food/$id': typeof AuthenticatedCollectionsFoodIdRoute
  '/groups/$id/manage': typeof AuthenticatedGroupsIdManageRoute
  '/personal/food-log/$date': typeof AuthenticatedPersonalFoodLogDateRoute
  '/personal/lists/$id': typeof AuthenticatedPersonalListsIdRoute
  '/personal/meal-plans/$id': typeof AuthenticatedPersonalMealPlansIdRoute
  '/personal/planned-meals/$date': typeof AuthenticatedPersonalPlannedMealsDateRoute
  '/personal/recipes/create': typeof AuthenticatedPersonalRecipesCreateRoute
  '/recipes/$id/edit': typeof AuthenticatedRecipesIdEditRoute
  '/admin/ai-issues': typeof AdminAdminAiIssuesIndexRoute
  '/admin/users': typeof AdminAdminUsersIndexRoute
  '/groups/$id': typeof AuthenticatedGroupsIdIndexRoute
  '/personal/collections': typeof AuthenticatedPersonalCollectionsIndexRoute
  '/personal/food-log': typeof AuthenticatedPersonalFoodLogIndexRoute
  '/personal/lists': typeof AuthenticatedPersonalListsIndexRoute
  '/personal/meal-planning-sessions': typeof AuthenticatedPersonalMealPlanningSessionsIndexRoute
  '/personal/meal-plans': typeof AuthenticatedPersonalMealPlansIndexRoute
  '/personal/planned-meals': typeof AuthenticatedPersonalPlannedMealsIndexRoute
  '/personal/programs': typeof AuthenticatedPersonalProgramsIndexRoute
  '/personal/recipes': typeof AuthenticatedPersonalRecipesIndexRoute
  '/personal/collections/list/$id': typeof AuthenticatedPersonalCollectionsListIdRoute
  '/spaces/$spaceId/planned-meals/$date': typeof AuthenticatedSpacesSpaceIdPlannedMealsDateRoute
  '/spaces/$spaceId/recipes/create': typeof AuthenticatedSpacesSpaceIdRecipesCreateRoute
  '/spaces/$spaceId/collections': typeof AuthenticatedSpacesSpaceIdCollectionsIndexRoute
  '/spaces/$spaceId/meal-planning-sessions': typeof AuthenticatedSpacesSpaceIdMealPlanningSessionsIndexRoute
  '/spaces/$spaceId/planned-meals': typeof AuthenticatedSpacesSpaceIdPlannedMealsIndexRoute
  '/spaces/$spaceId/recipes': typeof AuthenticatedSpacesSpaceIdRecipesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_admin': typeof AdminRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_pending': typeof PendingRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteWithChildren
  '/_authenticated/home': typeof AuthenticatedHomeRoute
  '/_authenticated/planned-meals': typeof AuthenticatedPlannedMealsRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_pending/waitlist': typeof PendingWaitlistRoute
  '/_unauthenticated/login': typeof UnauthenticatedLoginRoute
  '/_authenticated/groups/$id': typeof AuthenticatedGroupsIdRouteWithChildren
  '/_authenticated/join/$token': typeof AuthenticatedJoinTokenRoute
  '/_authenticated/meal-planning-sessions/$id': typeof AuthenticatedMealPlanningSessionsIdRoute
  '/_authenticated/recipes/$id': typeof AuthenticatedRecipesIdRouteWithChildren
  '/_authenticated/collections/': typeof AuthenticatedCollectionsIndexRoute
  '/_authenticated/groups/': typeof AuthenticatedGroupsIndexRoute
  '/_authenticated/meal-planning-sessions/': typeof AuthenticatedMealPlanningSessionsIndexRoute
  '/_authenticated/recipes/': typeof AuthenticatedRecipesIndexRoute
  '/_admin/admin/ai-issues/$id': typeof AdminAdminAiIssuesIdRoute
  '/_authenticated/collections/food/$id': typeof AuthenticatedCollectionsFoodIdRoute
  '/_authenticated/groups/$id/manage': typeof AuthenticatedGroupsIdManageRoute
  '/_authenticated/personal/food-log/$date': typeof AuthenticatedPersonalFoodLogDateRoute
  '/_authenticated/personal/lists/$id': typeof AuthenticatedPersonalListsIdRoute
  '/_authenticated/personal/meal-plans/$id': typeof AuthenticatedPersonalMealPlansIdRoute
  '/_authenticated/personal/planned-meals/$date': typeof AuthenticatedPersonalPlannedMealsDateRoute
  '/_authenticated/personal/recipes/create': typeof AuthenticatedPersonalRecipesCreateRoute
  '/_authenticated/recipes/$id/edit': typeof AuthenticatedRecipesIdEditRoute
  '/_admin/admin/ai-issues/': typeof AdminAdminAiIssuesIndexRoute
  '/_admin/admin/users/': typeof AdminAdminUsersIndexRoute
  '/_authenticated/groups/$id/': typeof AuthenticatedGroupsIdIndexRoute
  '/_authenticated/personal/collections/': typeof AuthenticatedPersonalCollectionsIndexRoute
  '/_authenticated/personal/food-log/': typeof AuthenticatedPersonalFoodLogIndexRoute
  '/_authenticated/personal/lists/': typeof AuthenticatedPersonalListsIndexRoute
  '/_authenticated/personal/meal-planning-sessions/': typeof AuthenticatedPersonalMealPlanningSessionsIndexRoute
  '/_authenticated/personal/meal-plans/': typeof AuthenticatedPersonalMealPlansIndexRoute
  '/_authenticated/personal/planned-meals/': typeof AuthenticatedPersonalPlannedMealsIndexRoute
  '/_authenticated/personal/programs/': typeof AuthenticatedPersonalProgramsIndexRoute
  '/_authenticated/personal/recipes/': typeof AuthenticatedPersonalRecipesIndexRoute
  '/_authenticated/personal/collections/list/$id': typeof AuthenticatedPersonalCollectionsListIdRoute
  '/_authenticated/spaces/$spaceId/planned-meals/$date': typeof AuthenticatedSpacesSpaceIdPlannedMealsDateRoute
  '/_authenticated/spaces/$spaceId/recipes/create': typeof AuthenticatedSpacesSpaceIdRecipesCreateRoute
  '/_authenticated/spaces/$spaceId/collections/': typeof AuthenticatedSpacesSpaceIdCollectionsIndexRoute
  '/_authenticated/spaces/$spaceId/meal-planning-sessions/': typeof AuthenticatedSpacesSpaceIdMealPlanningSessionsIndexRoute
  '/_authenticated/spaces/$spaceId/planned-meals/': typeof AuthenticatedSpacesSpaceIdPlannedMealsIndexRoute
  '/_authenticated/spaces/$spaceId/recipes/': typeof AuthenticatedSpacesSpaceIdRecipesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/home'
    | '/planned-meals'
    | '/settings'
    | '/waitlist'
    | '/login'
    | '/groups/$id'
    | '/join/$token'
    | '/meal-planning-sessions/$id'
    | '/recipes/$id'
    | '/collections'
    | '/groups'
    | '/meal-planning-sessions'
    | '/recipes'
    | '/admin/ai-issues/$id'
    | '/collections/food/$id'
    | '/groups/$id/manage'
    | '/personal/food-log/$date'
    | '/personal/lists/$id'
    | '/personal/meal-plans/$id'
    | '/personal/planned-meals/$date'
    | '/personal/recipes/create'
    | '/recipes/$id/edit'
    | '/admin/ai-issues'
    | '/admin/users'
    | '/groups/$id/'
    | '/personal/collections'
    | '/personal/food-log'
    | '/personal/lists'
    | '/personal/meal-planning-sessions'
    | '/personal/meal-plans'
    | '/personal/planned-meals'
    | '/personal/programs'
    | '/personal/recipes'
    | '/personal/collections/list/$id'
    | '/spaces/$spaceId/planned-meals/$date'
    | '/spaces/$spaceId/recipes/create'
    | '/spaces/$spaceId/collections'
    | '/spaces/$spaceId/meal-planning-sessions'
    | '/spaces/$spaceId/planned-meals'
    | '/spaces/$spaceId/recipes'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/home'
    | '/planned-meals'
    | '/settings'
    | '/waitlist'
    | '/login'
    | '/join/$token'
    | '/meal-planning-sessions/$id'
    | '/recipes/$id'
    | '/collections'
    | '/groups'
    | '/meal-planning-sessions'
    | '/recipes'
    | '/admin/ai-issues/$id'
    | '/collections/food/$id'
    | '/groups/$id/manage'
    | '/personal/food-log/$date'
    | '/personal/lists/$id'
    | '/personal/meal-plans/$id'
    | '/personal/planned-meals/$date'
    | '/personal/recipes/create'
    | '/recipes/$id/edit'
    | '/admin/ai-issues'
    | '/admin/users'
    | '/groups/$id'
    | '/personal/collections'
    | '/personal/food-log'
    | '/personal/lists'
    | '/personal/meal-planning-sessions'
    | '/personal/meal-plans'
    | '/personal/planned-meals'
    | '/personal/programs'
    | '/personal/recipes'
    | '/personal/collections/list/$id'
    | '/spaces/$spaceId/planned-meals/$date'
    | '/spaces/$spaceId/recipes/create'
    | '/spaces/$spaceId/collections'
    | '/spaces/$spaceId/meal-planning-sessions'
    | '/spaces/$spaceId/planned-meals'
    | '/spaces/$spaceId/recipes'
  id:
    | '__root__'
    | '/'
    | '/_admin'
    | '/_authenticated'
    | '/_pending'
    | '/_unauthenticated'
    | '/_authenticated/home'
    | '/_authenticated/planned-meals'
    | '/_authenticated/settings'
    | '/_pending/waitlist'
    | '/_unauthenticated/login'
    | '/_authenticated/groups/$id'
    | '/_authenticated/join/$token'
    | '/_authenticated/meal-planning-sessions/$id'
    | '/_authenticated/recipes/$id'
    | '/_authenticated/collections/'
    | '/_authenticated/groups/'
    | '/_authenticated/meal-planning-sessions/'
    | '/_authenticated/recipes/'
    | '/_admin/admin/ai-issues/$id'
    | '/_authenticated/collections/food/$id'
    | '/_authenticated/groups/$id/manage'
    | '/_authenticated/personal/food-log/$date'
    | '/_authenticated/personal/lists/$id'
    | '/_authenticated/personal/meal-plans/$id'
    | '/_authenticated/personal/planned-meals/$date'
    | '/_authenticated/personal/recipes/create'
    | '/_authenticated/recipes/$id/edit'
    | '/_admin/admin/ai-issues/'
    | '/_admin/admin/users/'
    | '/_authenticated/groups/$id/'
    | '/_authenticated/personal/collections/'
    | '/_authenticated/personal/food-log/'
    | '/_authenticated/personal/lists/'
    | '/_authenticated/personal/meal-planning-sessions/'
    | '/_authenticated/personal/meal-plans/'
    | '/_authenticated/personal/planned-meals/'
    | '/_authenticated/personal/programs/'
    | '/_authenticated/personal/recipes/'
    | '/_authenticated/personal/collections/list/$id'
    | '/_authenticated/spaces/$spaceId/planned-meals/$date'
    | '/_authenticated/spaces/$spaceId/recipes/create'
    | '/_authenticated/spaces/$spaceId/collections/'
    | '/_authenticated/spaces/$spaceId/meal-planning-sessions/'
    | '/_authenticated/spaces/$spaceId/planned-meals/'
    | '/_authenticated/spaces/$spaceId/recipes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PendingRoute: typeof PendingRouteWithChildren
  UnauthenticatedRoute: typeof UnauthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_pending': {
      id: '/_pending'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated/login': {
      id: '/_unauthenticated/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthenticatedLoginRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_pending/waitlist': {
      id: '/_pending/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof PendingWaitlistRouteImport
      parentRoute: typeof PendingRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/planned-meals': {
      id: '/_authenticated/planned-meals'
      path: '/planned-meals'
      fullPath: '/planned-meals'
      preLoaderRoute: typeof AuthenticatedPlannedMealsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home': {
      id: '/_authenticated/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/recipes/': {
      id: '/_authenticated/recipes/'
      path: '/recipes'
      fullPath: '/recipes'
      preLoaderRoute: typeof AuthenticatedRecipesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/meal-planning-sessions/': {
      id: '/_authenticated/meal-planning-sessions/'
      path: '/meal-planning-sessions'
      fullPath: '/meal-planning-sessions'
      preLoaderRoute: typeof AuthenticatedMealPlanningSessionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/groups/': {
      id: '/_authenticated/groups/'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof AuthenticatedGroupsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/collections/': {
      id: '/_authenticated/collections/'
      path: '/collections'
      fullPath: '/collections'
      preLoaderRoute: typeof AuthenticatedCollectionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/recipes/$id': {
      id: '/_authenticated/recipes/$id'
      path: '/recipes/$id'
      fullPath: '/recipes/$id'
      preLoaderRoute: typeof AuthenticatedRecipesIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/meal-planning-sessions/$id': {
      id: '/_authenticated/meal-planning-sessions/$id'
      path: '/meal-planning-sessions/$id'
      fullPath: '/meal-planning-sessions/$id'
      preLoaderRoute: typeof AuthenticatedMealPlanningSessionsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/join/$token': {
      id: '/_authenticated/join/$token'
      path: '/join/$token'
      fullPath: '/join/$token'
      preLoaderRoute: typeof AuthenticatedJoinTokenRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/groups/$id': {
      id: '/_authenticated/groups/$id'
      path: '/groups/$id'
      fullPath: '/groups/$id'
      preLoaderRoute: typeof AuthenticatedGroupsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/personal/recipes/': {
      id: '/_authenticated/personal/recipes/'
      path: '/personal/recipes'
      fullPath: '/personal/recipes'
      preLoaderRoute: typeof AuthenticatedPersonalRecipesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/personal/programs/': {
      id: '/_authenticated/personal/programs/'
      path: '/personal/programs'
      fullPath: '/personal/programs'
      preLoaderRoute: typeof AuthenticatedPersonalProgramsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/personal/planned-meals/': {
      id: '/_authenticated/personal/planned-meals/'
      path: '/personal/planned-meals'
      fullPath: '/personal/planned-meals'
      preLoaderRoute: typeof AuthenticatedPersonalPlannedMealsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/personal/meal-plans/': {
      id: '/_authenticated/personal/meal-plans/'
      path: '/personal/meal-plans'
      fullPath: '/personal/meal-plans'
      preLoaderRoute: typeof AuthenticatedPersonalMealPlansIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/personal/meal-planning-sessions/': {
      id: '/_authenticated/personal/meal-planning-sessions/'
      path: '/personal/meal-planning-sessions'
      fullPath: '/personal/meal-planning-sessions'
      preLoaderRoute: typeof AuthenticatedPersonalMealPlanningSessionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/personal/lists/': {
      id: '/_authenticated/personal/lists/'
      path: '/personal/lists'
      fullPath: '/personal/lists'
      preLoaderRoute: typeof AuthenticatedPersonalListsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/personal/food-log/': {
      id: '/_authenticated/personal/food-log/'
      path: '/personal/food-log'
      fullPath: '/personal/food-log'
      preLoaderRoute: typeof AuthenticatedPersonalFoodLogIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/personal/collections/': {
      id: '/_authenticated/personal/collections/'
      path: '/personal/collections'
      fullPath: '/personal/collections'
      preLoaderRoute: typeof AuthenticatedPersonalCollectionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/groups/$id/': {
      id: '/_authenticated/groups/$id/'
      path: '/'
      fullPath: '/groups/$id/'
      preLoaderRoute: typeof AuthenticatedGroupsIdIndexRouteImport
      parentRoute: typeof AuthenticatedGroupsIdRoute
    }
    '/_admin/admin/users/': {
      id: '/_admin/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminAdminUsersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/admin/ai-issues/': {
      id: '/_admin/admin/ai-issues/'
      path: '/admin/ai-issues'
      fullPath: '/admin/ai-issues'
      preLoaderRoute: typeof AdminAdminAiIssuesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_authenticated/recipes/$id/edit': {
      id: '/_authenticated/recipes/$id/edit'
      path: '/edit'
      fullPath: '/recipes/$id/edit'
      preLoaderRoute: typeof AuthenticatedRecipesIdEditRouteImport
      parentRoute: typeof AuthenticatedRecipesIdRoute
    }
    '/_authenticated/personal/recipes/create': {
      id: '/_authenticated/personal/recipes/create'
      path: '/personal/recipes/create'
      fullPath: '/personal/recipes/create'
      preLoaderRoute: typeof AuthenticatedPersonalRecipesCreateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/personal/planned-meals/$date': {
      id: '/_authenticated/personal/planned-meals/$date'
      path: '/personal/planned-meals/$date'
      fullPath: '/personal/planned-meals/$date'
      preLoaderRoute: typeof AuthenticatedPersonalPlannedMealsDateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/personal/meal-plans/$id': {
      id: '/_authenticated/personal/meal-plans/$id'
      path: '/personal/meal-plans/$id'
      fullPath: '/personal/meal-plans/$id'
      preLoaderRoute: typeof AuthenticatedPersonalMealPlansIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/personal/lists/$id': {
      id: '/_authenticated/personal/lists/$id'
      path: '/personal/lists/$id'
      fullPath: '/personal/lists/$id'
      preLoaderRoute: typeof AuthenticatedPersonalListsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/personal/food-log/$date': {
      id: '/_authenticated/personal/food-log/$date'
      path: '/personal/food-log/$date'
      fullPath: '/personal/food-log/$date'
      preLoaderRoute: typeof AuthenticatedPersonalFoodLogDateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/groups/$id/manage': {
      id: '/_authenticated/groups/$id/manage'
      path: '/manage'
      fullPath: '/groups/$id/manage'
      preLoaderRoute: typeof AuthenticatedGroupsIdManageRouteImport
      parentRoute: typeof AuthenticatedGroupsIdRoute
    }
    '/_authenticated/collections/food/$id': {
      id: '/_authenticated/collections/food/$id'
      path: '/collections/food/$id'
      fullPath: '/collections/food/$id'
      preLoaderRoute: typeof AuthenticatedCollectionsFoodIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_admin/admin/ai-issues/$id': {
      id: '/_admin/admin/ai-issues/$id'
      path: '/admin/ai-issues/$id'
      fullPath: '/admin/ai-issues/$id'
      preLoaderRoute: typeof AdminAdminAiIssuesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_authenticated/spaces/$spaceId/recipes/': {
      id: '/_authenticated/spaces/$spaceId/recipes/'
      path: '/spaces/$spaceId/recipes'
      fullPath: '/spaces/$spaceId/recipes'
      preLoaderRoute: typeof AuthenticatedSpacesSpaceIdRecipesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/spaces/$spaceId/planned-meals/': {
      id: '/_authenticated/spaces/$spaceId/planned-meals/'
      path: '/spaces/$spaceId/planned-meals'
      fullPath: '/spaces/$spaceId/planned-meals'
      preLoaderRoute: typeof AuthenticatedSpacesSpaceIdPlannedMealsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/spaces/$spaceId/meal-planning-sessions/': {
      id: '/_authenticated/spaces/$spaceId/meal-planning-sessions/'
      path: '/spaces/$spaceId/meal-planning-sessions'
      fullPath: '/spaces/$spaceId/meal-planning-sessions'
      preLoaderRoute: typeof AuthenticatedSpacesSpaceIdMealPlanningSessionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/spaces/$spaceId/collections/': {
      id: '/_authenticated/spaces/$spaceId/collections/'
      path: '/spaces/$spaceId/collections'
      fullPath: '/spaces/$spaceId/collections'
      preLoaderRoute: typeof AuthenticatedSpacesSpaceIdCollectionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/spaces/$spaceId/recipes/create': {
      id: '/_authenticated/spaces/$spaceId/recipes/create'
      path: '/spaces/$spaceId/recipes/create'
      fullPath: '/spaces/$spaceId/recipes/create'
      preLoaderRoute: typeof AuthenticatedSpacesSpaceIdRecipesCreateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/spaces/$spaceId/planned-meals/$date': {
      id: '/_authenticated/spaces/$spaceId/planned-meals/$date'
      path: '/spaces/$spaceId/planned-meals/$date'
      fullPath: '/spaces/$spaceId/planned-meals/$date'
      preLoaderRoute: typeof AuthenticatedSpacesSpaceIdPlannedMealsDateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/personal/collections/list/$id': {
      id: '/_authenticated/personal/collections/list/$id'
      path: '/personal/collections/list/$id'
      fullPath: '/personal/collections/list/$id'
      preLoaderRoute: typeof AuthenticatedPersonalCollectionsListIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAdminAiIssuesIdRoute: typeof AdminAdminAiIssuesIdRoute
  AdminAdminAiIssuesIndexRoute: typeof AdminAdminAiIssuesIndexRoute
  AdminAdminUsersIndexRoute: typeof AdminAdminUsersIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAdminAiIssuesIdRoute: AdminAdminAiIssuesIdRoute,
  AdminAdminAiIssuesIndexRoute: AdminAdminAiIssuesIndexRoute,
  AdminAdminUsersIndexRoute: AdminAdminUsersIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AuthenticatedGroupsIdRouteChildren {
  AuthenticatedGroupsIdManageRoute: typeof AuthenticatedGroupsIdManageRoute
  AuthenticatedGroupsIdIndexRoute: typeof AuthenticatedGroupsIdIndexRoute
}

const AuthenticatedGroupsIdRouteChildren: AuthenticatedGroupsIdRouteChildren = {
  AuthenticatedGroupsIdManageRoute: AuthenticatedGroupsIdManageRoute,
  AuthenticatedGroupsIdIndexRoute: AuthenticatedGroupsIdIndexRoute,
}

const AuthenticatedGroupsIdRouteWithChildren =
  AuthenticatedGroupsIdRoute._addFileChildren(
    AuthenticatedGroupsIdRouteChildren,
  )

interface AuthenticatedRecipesIdRouteChildren {
  AuthenticatedRecipesIdEditRoute: typeof AuthenticatedRecipesIdEditRoute
}

const AuthenticatedRecipesIdRouteChildren: AuthenticatedRecipesIdRouteChildren =
  {
    AuthenticatedRecipesIdEditRoute: AuthenticatedRecipesIdEditRoute,
  }

const AuthenticatedRecipesIdRouteWithChildren =
  AuthenticatedRecipesIdRoute._addFileChildren(
    AuthenticatedRecipesIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedPlannedMealsRoute: typeof AuthenticatedPlannedMealsRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedGroupsIdRoute: typeof AuthenticatedGroupsIdRouteWithChildren
  AuthenticatedJoinTokenRoute: typeof AuthenticatedJoinTokenRoute
  AuthenticatedMealPlanningSessionsIdRoute: typeof AuthenticatedMealPlanningSessionsIdRoute
  AuthenticatedRecipesIdRoute: typeof AuthenticatedRecipesIdRouteWithChildren
  AuthenticatedCollectionsIndexRoute: typeof AuthenticatedCollectionsIndexRoute
  AuthenticatedGroupsIndexRoute: typeof AuthenticatedGroupsIndexRoute
  AuthenticatedMealPlanningSessionsIndexRoute: typeof AuthenticatedMealPlanningSessionsIndexRoute
  AuthenticatedRecipesIndexRoute: typeof AuthenticatedRecipesIndexRoute
  AuthenticatedCollectionsFoodIdRoute: typeof AuthenticatedCollectionsFoodIdRoute
  AuthenticatedPersonalFoodLogDateRoute: typeof AuthenticatedPersonalFoodLogDateRoute
  AuthenticatedPersonalListsIdRoute: typeof AuthenticatedPersonalListsIdRoute
  AuthenticatedPersonalMealPlansIdRoute: typeof AuthenticatedPersonalMealPlansIdRoute
  AuthenticatedPersonalPlannedMealsDateRoute: typeof AuthenticatedPersonalPlannedMealsDateRoute
  AuthenticatedPersonalRecipesCreateRoute: typeof AuthenticatedPersonalRecipesCreateRoute
  AuthenticatedPersonalCollectionsIndexRoute: typeof AuthenticatedPersonalCollectionsIndexRoute
  AuthenticatedPersonalFoodLogIndexRoute: typeof AuthenticatedPersonalFoodLogIndexRoute
  AuthenticatedPersonalListsIndexRoute: typeof AuthenticatedPersonalListsIndexRoute
  AuthenticatedPersonalMealPlanningSessionsIndexRoute: typeof AuthenticatedPersonalMealPlanningSessionsIndexRoute
  AuthenticatedPersonalMealPlansIndexRoute: typeof AuthenticatedPersonalMealPlansIndexRoute
  AuthenticatedPersonalPlannedMealsIndexRoute: typeof AuthenticatedPersonalPlannedMealsIndexRoute
  AuthenticatedPersonalProgramsIndexRoute: typeof AuthenticatedPersonalProgramsIndexRoute
  AuthenticatedPersonalRecipesIndexRoute: typeof AuthenticatedPersonalRecipesIndexRoute
  AuthenticatedPersonalCollectionsListIdRoute: typeof AuthenticatedPersonalCollectionsListIdRoute
  AuthenticatedSpacesSpaceIdPlannedMealsDateRoute: typeof AuthenticatedSpacesSpaceIdPlannedMealsDateRoute
  AuthenticatedSpacesSpaceIdRecipesCreateRoute: typeof AuthenticatedSpacesSpaceIdRecipesCreateRoute
  AuthenticatedSpacesSpaceIdCollectionsIndexRoute: typeof AuthenticatedSpacesSpaceIdCollectionsIndexRoute
  AuthenticatedSpacesSpaceIdMealPlanningSessionsIndexRoute: typeof AuthenticatedSpacesSpaceIdMealPlanningSessionsIndexRoute
  AuthenticatedSpacesSpaceIdPlannedMealsIndexRoute: typeof AuthenticatedSpacesSpaceIdPlannedMealsIndexRoute
  AuthenticatedSpacesSpaceIdRecipesIndexRoute: typeof AuthenticatedSpacesSpaceIdRecipesIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedPlannedMealsRoute: AuthenticatedPlannedMealsRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedGroupsIdRoute: AuthenticatedGroupsIdRouteWithChildren,
  AuthenticatedJoinTokenRoute: AuthenticatedJoinTokenRoute,
  AuthenticatedMealPlanningSessionsIdRoute:
    AuthenticatedMealPlanningSessionsIdRoute,
  AuthenticatedRecipesIdRoute: AuthenticatedRecipesIdRouteWithChildren,
  AuthenticatedCollectionsIndexRoute: AuthenticatedCollectionsIndexRoute,
  AuthenticatedGroupsIndexRoute: AuthenticatedGroupsIndexRoute,
  AuthenticatedMealPlanningSessionsIndexRoute:
    AuthenticatedMealPlanningSessionsIndexRoute,
  AuthenticatedRecipesIndexRoute: AuthenticatedRecipesIndexRoute,
  AuthenticatedCollectionsFoodIdRoute: AuthenticatedCollectionsFoodIdRoute,
  AuthenticatedPersonalFoodLogDateRoute: AuthenticatedPersonalFoodLogDateRoute,
  AuthenticatedPersonalListsIdRoute: AuthenticatedPersonalListsIdRoute,
  AuthenticatedPersonalMealPlansIdRoute: AuthenticatedPersonalMealPlansIdRoute,
  AuthenticatedPersonalPlannedMealsDateRoute:
    AuthenticatedPersonalPlannedMealsDateRoute,
  AuthenticatedPersonalRecipesCreateRoute:
    AuthenticatedPersonalRecipesCreateRoute,
  AuthenticatedPersonalCollectionsIndexRoute:
    AuthenticatedPersonalCollectionsIndexRoute,
  AuthenticatedPersonalFoodLogIndexRoute:
    AuthenticatedPersonalFoodLogIndexRoute,
  AuthenticatedPersonalListsIndexRoute: AuthenticatedPersonalListsIndexRoute,
  AuthenticatedPersonalMealPlanningSessionsIndexRoute:
    AuthenticatedPersonalMealPlanningSessionsIndexRoute,
  AuthenticatedPersonalMealPlansIndexRoute:
    AuthenticatedPersonalMealPlansIndexRoute,
  AuthenticatedPersonalPlannedMealsIndexRoute:
    AuthenticatedPersonalPlannedMealsIndexRoute,
  AuthenticatedPersonalProgramsIndexRoute:
    AuthenticatedPersonalProgramsIndexRoute,
  AuthenticatedPersonalRecipesIndexRoute:
    AuthenticatedPersonalRecipesIndexRoute,
  AuthenticatedPersonalCollectionsListIdRoute:
    AuthenticatedPersonalCollectionsListIdRoute,
  AuthenticatedSpacesSpaceIdPlannedMealsDateRoute:
    AuthenticatedSpacesSpaceIdPlannedMealsDateRoute,
  AuthenticatedSpacesSpaceIdRecipesCreateRoute:
    AuthenticatedSpacesSpaceIdRecipesCreateRoute,
  AuthenticatedSpacesSpaceIdCollectionsIndexRoute:
    AuthenticatedSpacesSpaceIdCollectionsIndexRoute,
  AuthenticatedSpacesSpaceIdMealPlanningSessionsIndexRoute:
    AuthenticatedSpacesSpaceIdMealPlanningSessionsIndexRoute,
  AuthenticatedSpacesSpaceIdPlannedMealsIndexRoute:
    AuthenticatedSpacesSpaceIdPlannedMealsIndexRoute,
  AuthenticatedSpacesSpaceIdRecipesIndexRoute:
    AuthenticatedSpacesSpaceIdRecipesIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PendingRouteChildren {
  PendingWaitlistRoute: typeof PendingWaitlistRoute
}

const PendingRouteChildren: PendingRouteChildren = {
  PendingWaitlistRoute: PendingWaitlistRoute,
}

const PendingRouteWithChildren =
  PendingRoute._addFileChildren(PendingRouteChildren)

interface UnauthenticatedRouteChildren {
  UnauthenticatedLoginRoute: typeof UnauthenticatedLoginRoute
}

const UnauthenticatedRouteChildren: UnauthenticatedRouteChildren = {
  UnauthenticatedLoginRoute: UnauthenticatedLoginRoute,
}

const UnauthenticatedRouteWithChildren = UnauthenticatedRoute._addFileChildren(
  UnauthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PendingRoute: PendingRouteWithChildren,
  UnauthenticatedRoute: UnauthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
